module.exports = __webpack_public_path__ + "static/img/door-gf3.ef608a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/door-gf/door-gf3.jpg
// module id = Z/yk
// module chunks = 0